<style lang="less" scoped>
.price-format{
  color: rgb(192,49,49);
  margin-left: -1px;
}
</style>
<template>
  <div class="price-format" :style="`color:${color};`">
    <slot name="left"></slot>
    <span class="unit" :style="`font-size:${fracSize}px`">￥</span><span class="int" :style="`font-size:${intSize}px`">{{intOfPrice}}</span><span class="dec" :style="`font-size:${decimalOfPriceSize}px`">{{decimalOfPrice}}</span>
    <slot name="right"></slot>
  </div>
</template>
<script>
import { priceConversion, priceFloat, priceInt } from '../util/function'

export default {
  // props: ['originPrice', 'intSize', 'fracSize', 'decimalSize', 'color'],
  props: {
    originPrice: {},
    intSize: {
      type: String,
      default: ''
    },
    fracSize: {
      type: String,
      default: ''
    },
    decimalSize: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },

  },
  data() {
    return {

    }
  },
  
  computed: {
    decimalOfPriceSize() {
      return this.decimalSize ? this.decimalSize : this.intSize
    },
    decimalOfPrice() {
      return priceFloat(priceConversion(this.originPrice))
    },
    intOfPrice() {
      return priceInt(priceConversion(this.originPrice))
    },
  },
}
</script>

